export const DELETE_IMAGE_REQUEST = 'DELETE_IMAGE_REQUEST';

export const deleteImageRequest = ( id: string ) => ({
    type: DELETE_IMAGE_REQUEST,
    payload: { id }
});
